var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.mainTable.sarchCardShow
            ? _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("search-card", {
                        attrs: {
                          form: _vm.mainTable.searchForm,
                          "table-load-event": _vm.getMainTableRecords,
                          "table-search": _vm.mainTable.tableSearch,
                          colSpan: 4,
                          searchBtnColSpan: 4,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "Card",
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("产品管理")]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _vm.$checkAccessArray(["B", "C"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                type: "warning",
                                size: "small",
                                shape: "circle",
                              },
                              on: { click: _vm.batchUpdateProductForNotShow },
                            },
                            [_vm._v("批量隐藏产品")]
                          )
                        : _vm._e(),
                      _vm.$checkAccessArray(["B", "C"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                type: "info",
                                size: "small",
                                shape: "circle",
                              },
                              on: { click: _vm.showAllProducts },
                            },
                            [_vm._v("显示隐藏产品")]
                          )
                        : _vm._e(),
                      _vm.$checkAccessArray(["B", "C"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                size: "small",
                                shape: "circle",
                                type: "success",
                                icon: "ios-add-circle-outline",
                              },
                              on: { click: _vm.onCreate },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.$checkAccessArray(["B", "C"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                size: "small",
                                type: "primary",
                                shape: "circle",
                              },
                              on: { click: _vm.onBaseBathEdit },
                            },
                            [_vm._v("批量编辑基础信息")]
                          )
                        : _vm._e(),
                      _vm.$checkAccessArray(["B", "C"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                size: "small",
                                shape: "circle",
                                type: "info",
                              },
                              on: { click: _vm.onBathEdit },
                            },
                            [_vm._v("批量编辑说明信息")]
                          )
                        : _vm._e(),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "info",
                            size: "small",
                            shape: "circle",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onExport()
                            },
                          },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    ref: "mainTable",
                    attrs: {
                      columns: _vm.mainTable.tableColumns,
                      data: _vm.mainTable.tableData,
                      loading: _vm.mainTable.tableLoading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                    },
                    on: { "on-selection-change": _vm.onSelectionChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ProductPopupEdit", {
        ref: "productPopupEdit",
        attrs: {
          "popup-edit-resource": _vm.popupEditResource,
          "product-uuid": _vm.popupEditProductUuid,
          "product-code": _vm.popupEditproductCode,
        },
        on: { "on-popup-submit-finish": _vm.popupSubmitFinish },
        model: {
          value: _vm.popupEditModalShow,
          callback: function ($$v) {
            _vm.popupEditModalShow = $$v
          },
          expression: "popupEditModalShow",
        },
      }),
      _c("ProductPopupEditBath", {
        attrs: {
          "popup-edit-resource": _vm.popupEditResource,
          productUuidsBathEdit: _vm.productUuidsBathEdit,
        },
        model: {
          value: _vm.popupEditModalBathShow,
          callback: function ($$v) {
            _vm.popupEditModalBathShow = $$v
          },
          expression: "popupEditModalBathShow",
        },
      }),
      _c("ProductPopupEditBaseBath", {
        attrs: {
          "popup-edit-resource": _vm.popupEditResource,
          productUuidsBathEdit: _vm.productUuidsBathEdit,
        },
        model: {
          value: _vm.popupEditModalBaseBathShow,
          callback: function ($$v) {
            _vm.popupEditModalBaseBathShow = $$v
          },
          expression: "popupEditModalBaseBathShow",
        },
      }),
      _c("ProductPopupInsertTemplate", {
        on: { "insert-by-template": _vm.insertByTemplate },
        model: {
          value: _vm.popupEditModalInsertTemplateShow,
          callback: function ($$v) {
            _vm.popupEditModalInsertTemplateShow = $$v
          },
          expression: "popupEditModalInsertTemplateShow",
        },
      }),
      _c(
        "Modal",
        {
          attrs: { width: "60", title: "禁售区域" },
          model: {
            value: _vm.blockDistModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.blockDistModal, "show", $$v)
            },
            expression: "blockDistModal.show",
          },
        },
        [
          _c(
            "Form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "省份" } },
                        [
                          _c(
                            "Select",
                            {
                              on: { "on-change": _vm.onBlockProvinceChange },
                              model: {
                                value: _vm.blockDistModal.form.provinceUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.blockDistModal.form,
                                    "provinceUuid",
                                    $$v
                                  )
                                },
                                expression: "blockDistModal.form.provinceUuid",
                              },
                            },
                            _vm._l(
                              _vm.popupEditResource.provinceOptions,
                              function (p) {
                                return _c(
                                  "Option",
                                  {
                                    key: p.regionUuid,
                                    attrs: { value: p.regionUuid },
                                  },
                                  [_vm._v(_vm._s(p.regionName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "城市" } },
                        [
                          _c(
                            "Select",
                            {
                              on: { "on-change": _vm.onBlockCityChange },
                              model: {
                                value: _vm.blockDistModal.form.cityUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.blockDistModal.form,
                                    "cityUuid",
                                    $$v
                                  )
                                },
                                expression: "blockDistModal.form.cityUuid",
                              },
                            },
                            _vm._l(
                              _vm.blockDistModal.cityOptions,
                              function (c) {
                                return _c(
                                  "Option",
                                  {
                                    key: c.regionUuid,
                                    attrs: { value: c.regionUuid },
                                  },
                                  [_vm._v(_vm._s(c.regionName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "区域" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.blockDistModal.form.distUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.blockDistModal.form,
                                    "distUuid",
                                    $$v
                                  )
                                },
                                expression: "blockDistModal.form.distUuid",
                              },
                            },
                            _vm._l(
                              _vm.blockDistModal.distOptions,
                              function (d) {
                                return _c(
                                  "Option",
                                  {
                                    key: d.regionUuid,
                                    attrs: { value: d.regionUuid },
                                  },
                                  [_vm._v(_vm._s(d.regionName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "类型" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.blockDistModal.form.blockType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.blockDistModal.form,
                                    "blockType",
                                    $$v
                                  )
                                },
                                expression: "blockDistModal.form.blockType",
                              },
                            },
                            _vm._l(["预售", "现售"], function (t) {
                              return _c(
                                "Option",
                                { key: t, attrs: { value: t } },
                                [_vm._v(_vm._s(t))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "2" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: " " } },
                        [
                          _c(
                            "Button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onAddProductBlock },
                            },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("Table", {
                    attrs: {
                      columns: _vm.blockDistModal.table.columns,
                      size: "small",
                      data: _vm.blockDistModal.table.rows,
                      stripe: "",
                      border: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onSetProductBlock },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { width: "60", title: "专售页" },
          model: {
            value: _vm.privateSaleModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.privateSaleModal, "show", $$v)
            },
            expression: "privateSaleModal.show",
          },
        },
        [
          _c(
            "Form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "客户" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { filterable: "" },
                              model: {
                                value: _vm.privateSaleModal.customerUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.privateSaleModal,
                                    "customerUuid",
                                    $$v
                                  )
                                },
                                expression: "privateSaleModal.customerUuid",
                              },
                            },
                            _vm._l(_vm.externalCustomerUsers, function (p) {
                              return _c(
                                "Option",
                                {
                                  key: p.userUuid,
                                  attrs: { value: p.userUuid },
                                },
                                [
                                  _vm._v(
                                    _vm._s(p.userPersonName) +
                                      " （" +
                                      _vm._s(p.userName) +
                                      "）"
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "2" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: " " } },
                        [
                          _c(
                            "Button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onAddPrivateSale },
                            },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("Table", {
                    attrs: {
                      columns: _vm.privateSaleModal.table.columns,
                      size: "small",
                      data: _vm.privateSaleModal.table.rows,
                      stripe: "",
                      border: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onUpdatePrivateSale },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { width: "60", title: "特定区域提成" },
          model: {
            value: _vm.commissionDistModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.commissionDistModal, "show", $$v)
            },
            expression: "commissionDistModal.show",
          },
        },
        [
          _c(
            "Form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "省份" } },
                        [
                          _c(
                            "Select",
                            {
                              on: {
                                "on-change": _vm.onCommissionProvinceChange,
                              },
                              model: {
                                value:
                                  _vm.commissionDistModal.form.provinceUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.commissionDistModal.form,
                                    "provinceUuid",
                                    $$v
                                  )
                                },
                                expression:
                                  "commissionDistModal.form.provinceUuid",
                              },
                            },
                            _vm._l(
                              _vm.popupEditResource.provinceOptions,
                              function (p) {
                                return _c(
                                  "Option",
                                  {
                                    key: p.regionUuid,
                                    attrs: { value: p.regionUuid },
                                  },
                                  [_vm._v(_vm._s(p.regionName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "城市" } },
                        [
                          _c(
                            "Select",
                            {
                              on: { "on-change": _vm.onCommissionCityChange },
                              model: {
                                value: _vm.commissionDistModal.form.cityUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.commissionDistModal.form,
                                    "cityUuid",
                                    $$v
                                  )
                                },
                                expression: "commissionDistModal.form.cityUuid",
                              },
                            },
                            _vm._l(
                              _vm.commissionDistModal.cityOptions,
                              function (c) {
                                return _c(
                                  "Option",
                                  {
                                    key: c.regionUuid,
                                    attrs: { value: c.regionUuid },
                                  },
                                  [_vm._v(_vm._s(c.regionName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "区域" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.commissionDistModal.form.distUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.commissionDistModal.form,
                                    "distUuid",
                                    $$v
                                  )
                                },
                                expression: "commissionDistModal.form.distUuid",
                              },
                            },
                            _vm._l(
                              _vm.commissionDistModal.distOptions,
                              function (d) {
                                return _c(
                                  "Option",
                                  {
                                    key: d.regionUuid,
                                    attrs: { value: d.regionUuid },
                                  },
                                  [_vm._v(_vm._s(d.regionName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "类型" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value:
                                  _vm.commissionDistModal.form.commissionType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.commissionDistModal.form,
                                    "commissionType",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n                                commissionDistModal.form.commissionType\n                            ",
                              },
                            },
                            _vm._l(["预售", "现售"], function (t) {
                              return _c(
                                "Option",
                                { key: t, attrs: { value: t } },
                                [_vm._v(_vm._s(t))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "提成" } },
                        [
                          _c("decimal-input", {
                            attrs: { precision: 4, min: 0 },
                            model: {
                              value:
                                _vm.commissionDistModal.form.commissionValue,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.commissionDistModal.form,
                                  "commissionValue",
                                  $$v
                                )
                              },
                              expression:
                                "\n                                commissionDistModal.form.commissionValue\n                            ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "2" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: " " } },
                        [
                          _c(
                            "Button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onAddCommission },
                            },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("Table", {
                    attrs: {
                      columns: _vm.commissionDistModal.table.columns,
                      size: "small",
                      data: _vm.commissionDistModal.table.rows,
                      stripe: "",
                      border: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onSetSpecailCommission },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }